import http from '../../../Services/api.laravel.http';

export const UserLogService = {
 	getSingleUserLog: (id) => http.get('/admin/user-log/' + id),
  	ArchiveLog: (id) => http.put('/admin/user-log/archives/' + id),
  	paginateWithSearchUserLogs: (formParams) => http.post('/admin/user-log/search', formParams),
}
